import { Button, Header, Heading, Icon, Label, ModalClose, Stack, View } from '@fold-dev/core'
import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router'
import { Tiptap, TIPTAP_CONTENT_SAVE_TIMEOUT } from '.'
import { getMentionsfromTipTapJSON } from '../helpers'
import { useProjects } from '../hooks/api.hooks'
import { useAppStore } from '../store/app'
import { TbX } from 'react-icons/tb'

export const Overview = () => {
    const { projectId, workspaceId } = useParams()
    const [team, setTeam] = useState<any>({})
    const [overview, setOverview] = useState('')
    const projectsAPI = useProjects()
    const actions = useAppStore((state) => state.actions)
    const project = useAppStore((state) => state.project)
    const ref = useRef(null)
    const timeout = useRef(null)

    const handleUpdate = (html, json, editor) => {
        clearTimeout(timeout.current)
        timeout.current = setTimeout(() => handleOverviewSave(html, json, editor), TIPTAP_CONTENT_SAVE_TIMEOUT)
    }

    const handleOverviewSave = async (html, json, editor) => {
        const overview = html
        const mentions = getMentionsfromTipTapJSON(json)
        const project = { id: projectId, overview }

        actions.projectUpdate(project)
        setOverview(overview)
        await projectsAPI.update(workspaceId, projectId, project)
    }

    useEffect(() => {
        setOverview(project.overview)
    }, [project])

    return (
        <>
            <Header
                bgToken="sidebar"
                height="var(---header-sidebar-height)"
                p="0 1rem">
                <View
                    width="100%"
                    position="relative"
                    row>
                    <Heading
                        as="h5"
                        width="100%"
                        style={{ textTransform: 'capitalize' }}>
                        Notes
                    </Heading>
                    <Button
                        size="xs"
                        bgToken="surface-strong"
                        onClick={() => actions.setSidebar(null)}>
                        <Icon
                            icon={TbX}
                            size="sm"
                        />
                    </Button>
                </View>
            </Header>
            <View
                flex={1}
                width="100%"
                bgToken="sidebar"
                position="relative"
                onClick={() => ref.current?.firstChild?.focus()}>
                <div className="f-overflow-y-auto project-overview">
                    <Tiptap
                        updateAfterBlur
                        ref={ref}
                        content={overview}
                        onUpdate={handleUpdate}
                        workspaceId={workspaceId}
                        projectId={projectId}
                        teamId={project.teamId}
                        hideToolbar
                    />
                </div>
            </View>
        </>
    )
}
